import React, { FC } from "react";
import "../styles.css";

const Hero: FC = () => {
  return (
    <section className="container hero">
      <div>
        <img src="/images/JobLens360-Logo.png" width="475" alt="JobLens360 Hero Graphic" />
      </div>
      <div className="hero-content">
        <h2>Cut through job description noise.<br/>See where you really stand.</h2>
        <p className="sub">
          JobLens360 instantly analyzes any job posting and shows a clear,
          honest fit score — no fluff, just facts.
          AI disqualifies people for missing nuance, and JobLens360 exists to restore it.
        </p>
        {/* <p className="sub">
          “If your interview process fails when candidates use modern tools, your process is broken - not the candidates.”
        </p> */}
      </div>
      {/*<div className="hero-card">
        <div className="card">
          <div className="card-header">
            <span>Demo • Fit Score</span>
          </div>
          <div className="card-body">
            <div className="score-row">
              <span>Signal / Noise</span>
              <div className="bar">
                <div className="bar-fill" style={{ width: "72%" }} />
              </div>
              <span className="score">72</span>
            </div>
            <div className="score-row">
              <span>Skills Match</span>
              <div className="bar">
                <div className="bar-fill alt" style={{ width: "65%" }} />
              </div>
              <span className="score">65</span>
            </div>
            <div className="score-row">
              <span>Clarity</span>
              <div className="bar">
                <div className="bar-fill" style={{ width: "81%" }} />
              </div>
              <span className="score">81</span>
            </div>
            <p className="tint">
              Paste a JD and we’ll compute this for real. No account required.
            </p>
          </div>
        </div>
      </div>*/}
    </section>
  );
};

export default Hero;
